export enum ResponseTypeEnum {
  Success,
  Error,
}
